import { useSyncExternalStore } from 'react';
import { getSession, subscribeSession, type InspectorSession } from '@/lib/api';

export function useSession(): InspectorSession | null {
  return useSyncExternalStore(subscribeSession, getSession);
}
